export const environment = {
  production: false,
  baseUrl: null,
  //baseUrl: "http://localhost:5010",
  loginUrl: "/account/login"
};



// WEBPACK FOOTER //
// D:/Projects/Empower360Plus/EmpowerWeb2.0/A4.Empower/A4.Empower/ClientApp/src/environments/environment.ts